import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/code.svg'
import _imports_2 from '../assets/save.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c78a5bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-inner" }
const _hoisted_2 = {
  class: "header-table",
  cellspacing: "0"
}
const _hoisted_3 = { class: "icon-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "heading" }, "Edit Topic", -1))
const _hoisted_7 = { class: "icon-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "icon-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "edit-options-div" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_15 = { class: "button-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!

  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.saveAndExit()), ["enter"])),
        tabindex: "0"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveAndExit())),
                  title: "Save and exit"
                }, _hoisted_5)
              ]),
              _hoisted_6,
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCode()))
                }, _hoisted_9)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
                }, _hoisted_12)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "name-input",
              placeholder: "Enter topic name...",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.name]
            ]),
            _hoisted_14,
            _createElementVNode("div", null, [
              _createTextVNode(" Message Type "),
              _createElementVNode("button", {
                class: "icon-button new-msg-button",
                title: "Create new message type",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewCustomMsg()))
              }, [
                _createVNode(_component_fa, { icon: "plus" })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_SearchableDropDown, {
                ref: "topic_msg_dropdown",
                options: _ctx.allMsgs,
                "max-item": 10,
                placeholder: "Select message type",
                onSelected: _ctx.chooseTopicMsgType,
                "initially-selected": 
              _ctx.allMsgs.find((msg) => _ctx.topicToEdit?.msgType == msg.id)
            
              }, null, 8, ["options", "onSelected", "initially-selected"]),
              (_ctx.isCustomMsg)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "icon-button new-msg-button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onMsgEdit()))
                  }, [
                    _createVNode(_component_fa, { icon: "pencil" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCustomMsg)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "icon-button new-msg-button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onMsgTrash()))
                  }, [
                    _createVNode(_component_fa, { icon: "trash" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "dialog-bg",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveAndExit()))
        })
      ], 32))
    : _createCommentVNode("", true)
}